export class ClusterKey {
  constructor(private value: string) {}

  setValue(value: string): void {
    this.value = value;
  }

  getValue(): {} {
    return this.value;
  }
}
